import { React, useContext } from "react";
import TextField from "@mui/material/TextField";
import ThemeContext from "../../lib/theme-context";

const CustomSingleTextField = ({
  variant,
  type,
  size,
  label,
  value,
  onChange,
  onBlur,
  inputProps,
  InputProps,
  placeholder,
  disabled,
}) => {
  const theme = useContext(ThemeContext);

  return (
    <TextField
    
      inputProps={{
        ...inputProps,
        placeholder: placeholder || label,
      }}
      InputProps={InputProps}
      variant={variant}
      type={type}
      size={size}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      disabled={disabled}
      fullWidth
      sx={{
        marginRight: "1em",
        height: "50px",
        "& fieldset": {
          // - The <fieldset> inside the Input-root
          borderColor:
            theme[0] === "dark" ? "#FCFCFF" : "rgba(40, 42, 46)"  , // - Set the Input border
        },
        "&:hover fieldset": {
          borderColor:
            theme[0] === "dark" ? "#FCFCFF" : "rgba(40, 42, 46)"  , // - Set the Input border when parent has :hover
        },
        "&.Mui-focused fieldset": {
          // - Set the Input border when parent is focused
          borderColor:
            theme[0] === "dark" ? "#FCFCFF" : "rgba(40, 42, 46)"  ,
        },
        input: {
          color: theme[0] === "dark" ? "#FCFCFF" : "black",
        },

        "& label": {
          // - The <fieldset> inside the Input-root
          borderColor:
            theme[0] === "dark" ? "#FCFCFF" : "rgba(40, 42, 46)"  , // - Set the Input border
        },
        "&:hover label": {
          borderColor:
            theme[0] === "dark" ? "#FCFCFF" : "rgba(40, 42, 46)"  , // - Set the Input border when parent has :hover
        },
        "&.Mui-focused label": {
          // - Set the Input border when parent is focused
          borderColor:
            theme[0] === "dark" ? "#FCFCFF" : "rgba(40, 42, 46)"  ,
        },
        
        // Style number input arrows/spinners
        "& input[type=number]::-webkit-inner-spin-button, & input[type=number]::-webkit-outer-spin-button": {
          WebkitAppearance: "none",
          margin: 0,
        },
        "& input[type=number]": {
          MozAppearance: "textfield",
        },
      }}
    />
  );
};

export default CustomSingleTextField;
